export default [
    {
        path: '/prerequisite/locations',

        name: 'Locations',

        component: () => import('@/views/prerequisite/locations'),
    },
];